import React, { useState, useEffect, useRef } from 'react';
import { AudioOutlined } from '@ant-design/icons';
import { Tree,Input } from 'antd';
import '../App.css'
const { Search } = Input;
const NavTree = ({ json, defaultSelectedKeys }) => {
  const [data, setData] = useState([]);
  const [defaultExpandedKeys, setdefaultExpandedKeys] = useState([]);
  const [searchKeyword, setSearchKeyword] = useState('');
  const [defaultExpandAll,setdefaultExpandAll] = useState(false)
  // 读取json文件
  useEffect(() => {
    setdefaultExpandedKeys([])
    fetch(json+'.json')
      .then((response) => response.json())
      .then((jsonData) => {
        setData(jsonData);
      });
  }, [json]);
  // 获取展开的父节点
  const getParentKeys = (data, key) => {
    // 判断是否有选中结构
    if (key) {
      // 寻找选中结构的所有父节点
      const parentKeys = [];
      const findParentKeys = (data, key) => {
        for (let i = 0; i < data.length; i++) {
          const node = data[i];
          if (node.name === key) {
            parentKeys.push(node.name);
            return true;
          }
          if (node.children) {
            if (findParentKeys(node.children, key)) {
              parentKeys.push(node.name);
              return true;
            }
          }
        }
        return false;
      };

      findParentKeys(data, key);
      return parentKeys
    }
    else {
      // 如果没有选中结构，就获取默认open为true的节点
      let openNodeNames = [];
      const traverseTree = (nodes) => {
        for (let i = 0; i < nodes.length; i++) {
          const node = nodes[i];
          if (node.open === true) {
            openNodeNames.push(node.name);
          }
          if (node.children) {
            traverseTree(node.children);
          }
        }
      };
      traverseTree(data);
      return openNodeNames;
    }


  };
  useEffect(() => {
    // 执行函数，将需要展开的父节点存入defaultExpandedKeys
    setdefaultExpandedKeys(getParentKeys(data, defaultSelectedKeys[0]))
  }, [data])
  // 设置选中函数
  const onSelect = (selectedKeys, info) => {
    console.log('selected', selectedKeys, info);
  };
  // 处理json，获取需要的值name和key跟结构前的span颜色标签
  const renderTreeNodes = (data, parentNodes = []) => {
    return data
      .map((node) => {
        const isMatched =
          searchKeyword !== "" &&
          node.name.toLowerCase().includes(searchKeyword.toLowerCase());
        let children = null;
  
        if (node.children) {
          children = renderTreeNodes(node.children, [...parentNodes, node]);
        }
  
        if (searchKeyword === "" || isMatched || (children && children.length > 0)) {
          const name = (
            <span>
              <span style={{ color: node.color, marginRight: "8px" }}>■</span>
              {isMatched ? (
                <span style={{ backgroundColor: "yellow" }}>{node.name}</span>
              ) : (
                node.name
              )}
            </span>
          );
  
          return (
            <Tree.TreeNode key={node.name} title={name}>
              {children}
            </Tree.TreeNode>
          );
        }
  
        return null;
      })
      .filter(Boolean); // 过滤掉所有 null 值
  };
  
  
  const Input_Change = (event) => {
    const inputValue = event.target.value;
    console.log(inputValue);
    if (inputValue==''){
      setdefaultExpandAll(false)
    }else{
      setdefaultExpandAll(true)
    }
    setSearchKeyword(inputValue);
  }
  // 返回树结构
  return (
    <div id='nav_div'>
    <Search onChange={Input_Change} placeholder="input search text"/>
    <div id='nav_tree'>
      
      {/* 判断默认展开的数组是否为空 */}
      {defaultExpandedKeys.length > 0 ? (
        <Tree
          // 控制defaultExpandAll更新
          key={`should_expand_${defaultExpandAll}`}
          showLine
          // 设置默认展开
          defaultExpandedKeys={defaultExpandedKeys}
          // 设置展开父级节点
          defaultExpandAll={defaultExpandAll}
          defaultExpandParent={false}
          // 设置默认选中
          defaultSelectedKeys={defaultSelectedKeys}
          // 设置调用选中函数
          onSelect={onSelect}
        >
          {/* 调用json处理函数 */}
          {renderTreeNodes(data)}
        </Tree>
      ) : (
        <p>Loading data...</p>
      )}
    </div>
    </div>
  );
};

export default NavTree;
